export default {
  validationSummaryTitle: 'Resumen de Validación de Plantilla de Datos',
  close: 'Cerrar',
  criticalErrorsTab: 'Errores Críticos',
  warningsTab: 'Advertencias',
  fileStructureErrors: 'Errores de Estructura de Archivo',
  columnWideDataErrors: 'Errores de Datos en Columnas',
  rowSpecificDataErrors: 'Errores de Datos en Filas Específicas',
  cellSpecificDataErrors: 'Errores de Datos en Celdas Específicas',
  affectedRowsList: 'lista de filas afectadas',
  affectedCellsList: 'lista de celdas afectadas',
  onlyFirst50: '(solo las primeras 50)',
  row: 'fila',
  rows: 'filas',
  cell: 'celda',
  cells: 'celdas',
  fileStructureWarnings: 'Advertencias de Estructura de Archivo',
  columnWideDataWarnings: 'Advertencias de Datos en Columnas',
  rowSpecificDataWarnings: 'Advertencias de Datos en Filas Específicas',
  uploadingFile: 'Subiendo',
  cancel: 'Cancelar',
  instructionsTitle: 'Instrucciones de Carga de Datos',
  instructionsHeader: 'Instrucciones',
  instructionsIntro: 'En esta sección, puedes subir los datos necesarios para entrenar tu modelo de marketing mix. Sigue estos pasos:',
  instructionsStep1: 'Descarga la plantilla de datos proporcionada.',
  instructionsStep2: 'Complétala siguiendo las instrucciones en las dos primeras hojas.',
  instructionsStep3: 'Sube la hoja de cálculo completada usando el botón "Subir Archivo".',
  instructionsValidation: 'El sistema validará automáticamente el contenido de tu archivo. Si es válido, verás un',
  instructionsValidationContinue: 'en Resultados de Validación, luego un Científico de Datos lo revisará manualmente y te informaremos si tenemos alguna pregunta adicional sobre los datos.',
  instructionsIfFails: 'Si la validación automática falla, significa que el sistema detectó problemas. Puedes hacer clic en',
  summaryReport: 'Informe Resumen',
  instructionsReviewDetails: 'y revisar los problemas en detalle. Hay dos tipos de problemas:',
  criticalErrorsDescription: 'impiden que el entrenamiento del modelo se lleve a cabo. Debes corregirlos y volver a subir el archivo.',
  warningsDescription: 'no necesariamente impiden el entrenamiento del modelo, pero deberías revisarlas cuidadosamente, corregir lo que parezca un error y volver a subir el archivo. Si crees que no son errores, puedes ignorar las advertencias.',
  dataBriefsUploadTitle: 'Carga de Briefs de Datos',
  dataBriefsCaption1: '1. Esta sección permite subir documentos estándar de Brief con los requisitos del proyecto. Por favor descarga una copia',
  dataBriefsCaption1Link: 'aquí',
  dataBriefsCaption2: '2. Estos archivos serán revisados por nuestro equipo para entender tus requisitos de modelado.',
  approvalStatus: 'Estado de Aprobación',
  pending: 'Pendiente',
  dataBriefHeader: 'Brief de Datos',
  uploadedOnHeader: 'Fecha de Carga',
  uploaderHeader: 'Cargado Por',
  actionsHeader: 'Acciones',
  pleaseUploadDataBrief: 'Por favor sube tu brief de datos',
  approveBrief: 'Aprobar Brief',
  uploadDataBrief: 'Subir Brief de Datos',
  dataTemplatesUploadTitle: 'Carga de Plantillas de Datos',
  dataTemplatesCaption1: '1. Esta sección solo permite subir plantillas de datos estándar. Por favor descarga una copia',
  dataTemplatesCaption2: '2. Lee las instrucciones completas sobre cómo usar el cargador e interpretar los resultados',
  dataFileHeader: 'Archivo de Datos',
  validationResultsHeader: 'Resultados de Validación',
  validatingFile: 'Validando archivo',
  noErrorsFound: 'No se encontraron errores',
  criticalError: 'error crítico',
  criticalErrors: 'errores críticos',
  warning: 'advertencia',
  warnings: 'advertencias',
  fixErrorsFirst: 'Corregir Errores Primero',
  approveData: 'Aprobar Datos',
  pleaseUploadData: 'Por favor sube tus datos',
  uploadFile: 'Subir Archivo',
  unsupportedFileType: 'Tipo de archivo MIME no soportado',
  errorUploadingFile: 'Error al subir el archivo.',
  dataCheckDialogTitle: 'Template aprobado. ¿Quieres revisar tus datos?',
  dataCheckDialogText: 'La Revisión de Datos muestra tu template en gráficos simples, para que detectes períodos faltantes, picos o fechas corridas antes de empezar a modelar.',
  dataCheckDialogLater: 'Más tarde',
  dataCheckDialogGo: 'Ir a Revisión de Datos'
}
